import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProvidersFetchFailedAction = {
	type: 'AI_PROVIDERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProvidersFetchFailedAction => ({
	type: 'AI_PROVIDERS_FETCH_FAILED',
	payload,
});
